import { P2GBox, P2GChip, P2GLink, P2GLinkGroup, P2GGrid } from '@parcel2go/core-ui';
import DebouncedInput from '../../DebouncedInput';
import IncExc from './IncExc';
import { FilterOptionsGridProps } from './FilterOptionsGrid';
import IndexFade from './IndexFade';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const FilterOptionsGridCheckbox = (props: FilterOptionsGridProps) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const oo = props.filterItem.options
    .filter((x) => !props.search || x.value.toLowerCase().indexOf(props.search) > -1)
    .splice(0, props.limit);

  return (
    <IncExc
      mode={props.mode}
      setMode={props.setMode}
      ctr={
        <P2GLinkGroup
          links={[
            props.selected.length > 0 && (
              <P2GLink variant="body2" onClick={props.clearSelected}>
                {t('FILTER_OPTIONS_CLEAR', { defaultValue: 'Clear' })}
              </P2GLink>
            ),
            props.selected.length < props.filterItem.options.length && (
              <P2GLink variant="body2" onClick={props.selectAll}>
                {t('FILTER_OPTIONS_SELECT_ALL', { defaultValue: 'Select All' })}
              </P2GLink>
            ),
            props.filterItem.options.length > props.limit && (
              <P2GLink variant="body2" onClick={() => props.setLimit(props.limit + 10)}>
                {t('FILTER_OPTIONS_SHOW_MORE', { defaultValue: 'Show More' })}
              </P2GLink>
            )
          ]}
        />
      }
    >
      <P2GBox>
        {props.filterItem.options.length > 10 && (
          <P2GBox mb={2}>
            <DebouncedInput
              id="Search"
              label={t('SEARCH_INPUT_LABEL', { defaultValue: 'Search' })}
              value={props.search}
              onChange={props.setSearch}
            />
          </P2GBox>
        )}
        <P2GGrid container spacing={1}>
          {oo.map((o, i) => (
            <P2GGrid key={o.value} item flexShrink={1}>
              <IndexFade index={i}>
                <P2GChip
                  label={o.value}
                  color={'info'}
                  size="small"
                  onClick={() => props.toggleSelected(o.value)}
                  onDelete={props.isSelected(o.value) ? () => props.toggleSelected(o.value) : null}
                />
              </IndexFade>
            </P2GGrid>
          ))}
        </P2GGrid>
      </P2GBox>
    </IncExc>
  );
};
export default FilterOptionsGridCheckbox;
